import { z } from 'zod'

export const DEAL_STAGE  = ['NEW', 'CONTACT', 'NEGOTIATION', 'VIEWING', 'CONTRACT', 'ACTIVE', 'CLOSED', 'CANCELLED'] as const
export const DEAL_STATUS = ['ACTIVE', 'COMPLETED', 'CANCELLED'] as const

/** Money string — bigDecimal-compatible, e.g. "12345.67". Backend stores as Decimal. */
const moneySchema = z.string().regex(/^\d+(\.\d{1,2})?$/, 'Invalid amount').max(20)

const isoDateSchema = z.string().datetime({ offset: true })

export const dealCreateSchema = z.object({
	contactId:  z.string().min(1),
	propertyId: z.string().min(1).optional(),
	source:     z.string().max(50).optional(),
	amount:     moneySchema.optional(),
	currency:   z.string().length(3).optional(),
	startDate:  isoDateSchema.optional(),
	endDate:    isoDateSchema.optional(),
})

export const dealUpdateSchema = z.object({
	propertyId: z.string().min(1).optional(),
	amount:     moneySchema.optional(),
	currency:   z.string().length(3).optional(),
	startDate:  isoDateSchema.optional(),
	endDate:    isoDateSchema.optional(),
})

export const dealUpdateStageSchema  = z.object({ stage:  z.enum(DEAL_STAGE) })
export const dealUpdateStatusSchema = z.object({ status: z.enum(DEAL_STATUS) })

export type DealCreateInput       = z.infer<typeof dealCreateSchema>
export type DealUpdateInput       = z.infer<typeof dealUpdateSchema>
export type DealUpdateStageInput  = z.infer<typeof dealUpdateStageSchema>
export type DealUpdateStatusInput = z.infer<typeof dealUpdateStatusSchema>
